export default __webpack_public_path__ + "edd7b7cf94b2aeb8729aff4957bf3bdb.png";